module.exports = __webpack_public_path__ + "img/easy-OOOh3Px.svg";